/**
 * Get current scroll postion of page.
 */
export const getPageOffsetY = () => {
  return void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

/**
 * Get current scroll postion of page.
 */
export const getPageOffsetX = () => {
  return window.pageXOffset || document.body.scrollLeft || 0;
}

/**
 * Get scroll offset of element
 */
export const getElOffset = el => {
  return el.getBoundingClientRect().top + getPageOffsetY();
}

/**
 * Wrapper for getBoundingClientRect()
 * Not really needed.
 */
export const getBounds = el => {
  const rect = el.getBoundingClientRect();

  return {
    x: rect.left,
    y: rect.top,
    w: rect.width,
    h: rect.height
  };
}

/**
 * Get window width
 */
export const getWindowWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

/**
 * Get window height
 */
export const getWindowHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}
